import { render, staticRenderFns } from "./widget-settings-flat-item.vue?vue&type=template&id=0bfbd9b2&"
import script from "./widget-settings-flat-item.vue?vue&type=script&lang=js&"
export * from "./widget-settings-flat-item.vue?vue&type=script&lang=js&"
import style0 from "./widget-settings-flat-item.vue?vue&type=style&index=0&id=0bfbd9b2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports